import React from 'react';
import { GetSectionCustomizationOptions } from 'components/util';

const AdCustomizationOptions = GetSectionCustomizationOptions("AdOptions");

class AdComponent extends React.Component{
    render(){
        
        var imgArr = [];

        if(this.props.ads && this.props.ads.length > 0){
            imgArr = this.props.ads;
        }
        else if(AdCustomizationOptions && AdCustomizationOptions.AdsList && AdCustomizationOptions.AdsList.length > 0){
            imgArr = AdCustomizationOptions.AdsList;
        }

        var num = Math.floor(Math.random() * (imgArr.length - 0)) + 0;

        var cName = "col-xs-12 col-sm-6 col-md-4 ad-main-wrapper compact";
        if(this.props.classname && this.props.classname !== ""){
            //cName = this.props.classname + " ad-main-wrapper";
            cName = this.props.classname;
        }

        return (
            <div className={cName}>
                <div>
                    {imgArr[num] && imgArr[num].PhotoUrl && imgArr[num].PhotoUrl !== "" &&
                        <div className="ad-sub-wrapper"> 
                            <div>
                                {(imgArr[num].NavigateUrl && imgArr[num].NavigateUrl !== "") ?
                                    <a href={imgArr[num].NavigateUrl} target="_blank" rel="noopener noreferrer">
                                        <img src={imgArr[num].PhotoUrl} alt="" />
                                    </a> :
                                    <img src={imgArr[num].PhotoUrl} alt="" />
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default AdComponent;